/**
 * @file 日時を扱うためのUtility関数群
 */

import { formatInTimeZone } from 'date-fns-tz'

/**
 * 日時を表示型(日付)に変換
 * 例: 2022-02-17T00:00:00.000+09:00 → 2022月2月17日
 */
const getDispDate = (datetime_string) => {
  const date = new Date(datetime_string)

  return date.getFullYear() + '年' + (date.getMonth() + 1) + '月' + date.getDate() + '日'
}

/**
 * 日時を表示型(日付)に変換
 * 例: 2022-02-17T00:00:00.000+09:00 → 2022月2月17日
 */
const getDispDateDiff = (datetime_string_before, datetime_string_after) => {
  let date_before = null
  if (datetime_string_before === 'now') {
    date_before = new Date()
  } else {
    date_before = new Date(datetime_string_before)
  }

  let date_after = null
  if (datetime_string_after === 'now') {
    date_after = new Date()
  } else {
    date_after = new Date(datetime_string_after)
  }

  let date_diff = date_after - date_before
  const date_diff_year = Math.floor(date_diff / 1000 / 60 / 60 / 24 / 365)
  date_diff = date_diff - date_diff_year * 1000 * 60 * 60 * 24 * 365
  const date_diff_month = Math.floor(date_diff / 1000 / 60 / 60 / 24 / (365 / 12))

  return date_diff_year + '年' + date_diff_month + 'か月'
}

const formatTZ = (dateTimeString, formatStr = 'yyyy年M月d日', tz = 'Asia/Tokyo') => {
  if (!dateTimeString) return ''

  return formatInTimeZone(new Date(dateTimeString), tz, formatStr)
}

export { getDispDate, getDispDateDiff, formatTZ }
